<template>
  <div>
    <h1 class="heading text-4xl">Hello{{ name }}!</h1>
    <p class="my-4">&nbsp;</p>
    <form @submit.prevent="$emit('startCountdown', { name, id })">
      <label for="id" class="block">Race Number:</label>
      <input
        v-model.number.lazy="id"
        name="id"
        type="number"
        class="inline-block rounded border-2 border-blue-400 p-2 my-2 text-center"
        required
        @change="$emit('idChanged', id)"
      />
      <h4 class="text-main text-xl font-semibold my-2">{{ message }}</h4>
      <button
        type="submit"
        :disabled="message !== `Let's Go`"
        :class="{ disabled: message !== `Let's Go` }"
        class="button blue"
      >
        Start Game
      </button>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },

  data: function() {
    return {
      id: '',
      message: '',
      users: {},
    }
  },

  computed: {
    name: function() {
      const user = this.user

      if (user.name && user.started)
        this.message = 'Sorry, You have Already Run'
      else if (!user.name && this.id) this.message = 'Unknown Race Number'
      else if (!this.id) this.message = 'Please Enter Your Race Number'
      else this.message = `Let's Go`

      if (user.name) return ` ${user.name}`
      else return ''
    },
  },
}
</script>
<style>
input {
  width: 65%;
  margin-left: 17.5%;
  margin-right: 17.5%;
  transition: 0.5s;
  outline-color: blue;
}
</style>
